"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightAirportEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../../../Form/Field/Select/legacy");
const MultiLanguage_1 = require("../../../MultiLanguage");
const FlightAirportEditor = (props) => {
    const { label } = props;
    const { value, items, onValue, error, modifiers } = props.field;
    const { locale } = (0, react_intl_1.useIntl)();
    const fieldProps = {
        label,
        modificators: modifiers,
        name: 'origin',
        error,
        value: value === null || value === void 0 ? void 0 : value.code,
        onSelect: (item) => {
            const selectedItem = item === '' ? undefined : items === null || items === void 0 ? void 0 : items.filter(x => x.code === (item === null || item === void 0 ? void 0 : item.value)).pop();
            onValue(selectedItem);
        },
        items: [
            '',
            ...items.map((x) => ({
                name: (0, MultiLanguage_1.fMultilanguage)(x.name, locale),
                value: x.code,
            })),
        ],
    };
    return (react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...fieldProps }));
};
exports.FlightAirportEditor = FlightAirportEditor;
//# sourceMappingURL=FlightAirportEditor.js.map